export const generateID = () => {
    const now: string = Date.now().toString();
    const id: string = now + Math.random();
    return id.replace(".", "");
}